import type { Observable as ObservableType } from 'rxjs/Observable';
import fetchJson$ from '@atlassian/jira-fetch/src/utils/as-json-stream.tsx';
import type {
	GetVelocityCalculationTaskStatusResponse,
	StartVelocityCalculationTaskResponse,
} from './types';

/**
 * Starts a new asynchronous Velocity calculation task and returns an ID of the task.
 */
export const startVelocityCalculationTask = (
	rapidViewId: number,
): ObservableType<StartVelocityCalculationTaskResponse> =>
	fetchJson$('/rest/greenhopper/1.0/rapid/charts/async/velocity.json', {
		method: 'POST',
		body: JSON.stringify({ rapidViewId }),
	});

/**
 * Returns a status of a Velocity calculation task with the given ID.
 *
 * If the task is completed, a result will be included in a response.
 */
export const getVelocityCalculationTaskStatus = (
	taskId: string,
): ObservableType<GetVelocityCalculationTaskStatusResponse> =>
	fetchJson$(
		`/rest/greenhopper/1.0/rapid/charts/async/velocity/result.json?${new URLSearchParams({ taskId })}`,
	);
